<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu">评标澄清回复</div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">评标澄清回复</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>项目名称</span>
            <el-input type="text" class="input" v-model="Query.ProjectName" size="mini"></el-input>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="clarifyList" style="width: 100%">
            <el-table-column type="expand" style="padding: 0">
              <template slot-scope="props">
                <table class="statistics_table">
                  <tr>
                    <th class="th1">包组信息</th>
                    <th class="th1">澄清问题内容</th>
                    <th class="th1">状态</th>
                    <th class="th1">发布时间</th>
                    <th class="th1">回复截止时间</th>
                    <th class="th1" style="width: 240px">操作</th>
                  </tr>
                  <tr v-for="(item, index) in props.row.schemeList" :key="index">
                    <td class="td1">{{ item.ProjectName }}</td>
                    <td class="td1">{{ item.QuestionContent }}</td>
                    <td class="td1">
                      <div v-if="item.IsReply" class="tag-success"><span>已回复</span></div>
                      <div v-else class="tag-normal"><span>未回复</span></div>
                    </td>
                    <td class="td1">{{ item.CreateDate }}</td>
                    <td class="td1">{{ item.ReplyDeadline }}</td>
                    <td class="td1">
                      <div class="btn_wrap">
                        <el-button class="btn" v-if="!item.IsReply && item.CanReply" @click="fnReply(item.ReplyId, item.ClarifyId, index)" type="text" size="small"> 回复 </el-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </template>
            </el-table-column>
            <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称"></el-table-column>
            <el-table-column prop="PurchaseMethod" label="采购方式"></el-table-column>
            <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
            <!-- <el-table-column prop="QuestionContent" label="澄清问题内容"></el-table-column> -->
            <!-- <el-table-column prop="State" label="状态">
							<template slot-scope="scope">
								<span v-if="scope.row.IsReply">已回复</span>
								<span v-else>未回复</span>
							</template>
						</el-table-column>
						<el-table-column prop="CreateDate" label="发布时间"></el-table-column>
						<el-table-column prop="ReplyDeadline" label="回复截止时间"></el-table-column> -->
            <!-- <el-table-column prop="IsReply" label="操作" align="center">
              <template slot-scope="scope">
                <div class="btn_wrap">
                  <el-button class="btn" v-if="!scope.row.IsReply&& scope.row.CanReply"
                    @click="fnReply(scope.row.ReplyId, scope.row.ClarifyId, scope.$index)" type="text" size="small">
                    回复
                  </el-button>
                </div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationClarifyList',
  data() {
    return {
      Query: {
        ProjectName: ''
      },
      height: {
        height: ''
      },
      autoId: '',
      clarifyList: [],
      clarifyId: '',
      replyId: '',
      rowIndex: -1
    }
  },
  created() {
    // this.heightCom();
  },
  computed: {},
  mounted() {
    this.AddListener()
    this.fnGetData()
  },
  methods: {
    AddListener() {
      //监听（刷新列表）
      window.addEventListener('storage', (e) => {
        console.log(e.key)
        if (e.key == 'EvaluationClarifyList') {
          this.getData()
        }
      })
    },
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }
      this.getRequest('/EvaluationClarify/ClarifyList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.clarifyList = res.data.clarifyList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnUpload(id) {
      let routerData = this.$router.resolve({
        name: 'InvitationReciept',
        query: {
          id: id
        }
      })
      window.open(routerData.href, '_blank')
    },

    handleSelect(val) {
      console.log(val)
    },
    fnInit() {
      this.getRequest('Purchase/GetInvitationQueryList')
        .then((res) => {
          if (res.data.errcode == 0) {
            this.PurchaseMethods = res.data.PurchaseMethods
            this.ProjectTypes = res.data.ProjectTypes
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnReply(replyId, clarifyId, index) {
      let routerData = this.$router.resolve({
        name: 'Reply',
        query: {
          clarifyId: clarifyId,
          replyId: replyId,
          rowIndex: index
        }
      })
      window.open(routerData.href, '_blank')
      // console.log(scope);
      // console.log(replyId);
      // let config = {
      // 	params: {
      // 		autoId: replyId
      // 	}
      // };
      // this.getRequest('/QuestionManage/GetQuestions', config)
      // 	.then(res => {
      // 		if (res.data.errcode == 0) {
      // 			this.scheme = res.data.scheme;
      // 			this.autoId = autoId;
      // 			this.addQuestion = true;
      // 		} else {
      // 			this.$message.error(res.data.errmsg);
      // 		}
      // 	})
      // 	.catch(function(error) {
      // 		console.log(error);
      // 	});
    },
    updatereply(index) {
      if (index > -1) {
        this.clarifyList[index].IsReply = true
      }
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      height: 93%;
      background: #f7f7f7;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.statistics_table {
  width: 100%;
  // margin: 5px auto;

  th,
  td {
    text-align: center;
  }

  th {
    background-color: rgba(243, 251, 255, 1);
    color: #0179bd;
    font-weight: 700;
  }
  .tag-success {
    background-color: rgba(240, 249, 236, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(225, 243, 216, 1);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'Arial Normal', 'Arial';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #67c23a;
      text-align: center;
    }
  }

  .tag-danger {
    background-color: rgba(254, 241, 241, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(253, 226, 226, 1);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'PingFang SC Regular', 'PingFang SC';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #f56c6c;
      text-align: center;
    }
  }

  .tag-normal {
    background-color: rgb(236, 236, 236);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(211, 211, 211);
    border-radius: 5px;
    display: inline-block;
    line-height: 30px;
    span {
      padding: 0 12px;
      font-family: 'PingFang SC Regular', 'PingFang SC';
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: rgb(180, 180, 180);
      text-align: center;
    }
  }
}
</style>